<template>
  <!-- 物料类型管理 -->
  <basic-container>
    <!-- 搜索表单 -->
    <el-form label-width="100px">
      <el-row>
        <el-col span="6">
          <el-form-item label="项目名称：">
            <el-select style="width: 100%" v-model="projectId" placeholder="项目名称">
              <el-option
                v-for="(item, index) in projectList"
                :key="index"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="6">
          <el-form-item label="类型名称：">
            <el-input
              placeholder="类型名称"
              maxlength="30"
              show-word-limit
              clearable
              v-model="filterText"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item>
            <div style="float: right;">
              <el-button type="primary" icon="el-icon-search" size="small" @click="searchChange">
                搜索
              </el-button>
              <el-button plain icon="el-icon-delete" size="small" @click="searchReset">
                清空
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作按钮 -->
    <div class="btns">
      <el-button type="primary" icon="el-icon-add" size="small" @click="openFromDialog('addRoot')">
        添加一级
      </el-button>
    </div>
    <!-- 分类树 -->
    <div :style="'height:' + (bodyHeight - 280) + 'px; overflow: scroll;'">
      <el-tree
        ref="typeTree"
        node-key="id"
        :data="treeData"
        :props="typeTreeProps"
        :highlight-current="true"
        :default-expanded-keys="defaultExpandedKeys"
        :filter-node-method="filterTreeNode"
      >
        <span slot-scope="{ node }" class="custom-tree-node">
          <span :style="'color: ' + (node.data.status == 0 ? '#ccc' : '#000')">
            {{ node.label + '(' + node.data.fullCode + ')' }}
          </span>
          <span>
            <el-tooltip
              effect="dark"
              content="新增子目录"
              placement="top"
              v-if="permissionList.addBtn"
            >
              <i class="iconfont iconicon_subordinate" @click="openFromDialog('add', node)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="编辑" placement="top" v-if="permissionList.editBtn">
              <i class="iconfont iconicon_compile" @click="openFromDialog('edit', node)"></i>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="停用"
              placement="top"
              v-if="permissionList.switchBtn && node.data.status == 1"
            >
              <i class="el-icon-video-pause" @click="doSwitch(node)"></i>
            </el-tooltip>
            <el-tooltip
              effect="dark"
              content="启用"
              placement="top"
              v-if="permissionList.switchBtn && node.data.status == 0"
            >
              <i class="el-icon-video-play" @click="doSwitch(node)"></i>
            </el-tooltip>
          </span>
        </span>
      </el-tree>
    </div>
    <!-- 表单弹框 -->
    <el-dialog
      :title="formTitle"
      width="80%"
      :visible.sync="isFormDialogShow"
      :before-close="beforeCloseFormDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <WarehouseConsumableTypeForm
        v-if="isFormDialogShow"
        :formData="selectedNode"
        @update="updateData"
        @close="beforeCloseFormDialog"
      ></WarehouseConsumableTypeForm>
    </el-dialog>
  </basic-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { getProjectListApi } from '@/api/warehouse/index';
import { treeFree, remove } from '@/api/crmedical/warehouse/warehouseconsumabletype';
import WarehouseConsumableTypeForm from './warehouseconsumabletype-form';

export default {
  name: 'WarehouseConsumableType',
  components: {
    WarehouseConsumableTypeForm,
  },
  data() {
    return {
      // 项目列表
      projectList: [],
      // 项目id
      projectId: '',
      // 搜索关键字
      filterText: '',
      // 当前选中的节点
      selectedNode: {},
      // 表单弹框显示的标题
      formTitle: '',
      // 表单弹框是否显示着
      isFormDialogShow: false,
      // 分类树的数据
      treeData: {},
      // 物料类型树的节点属性
      typeTreeProps: {
        label: 'name',
        children: 'children',
      },
      // 树的默认展开节点
      defaultExpandedKeys: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.warehouseconsumabletype_add, false),
        viewBtn: this.vaildData(this.permission.warehouseconsumabletype_view, false),
        switchBtn: this.vaildData(this.permission.warehouseconsumabletype_delete, false), // fixme
        editBtn: this.vaildData(this.permission.warehouseconsumabletype_edit, false),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      this.projectId = this.projectList[0].id;
      this.loadData();
    });
  },
  methods: {
    /* 加载列表数据 */
    loadData() {
      if (this.projectList.length == 0) return;
      treeFree({
        projectId: this.projectId,
      }).then((res) => {
        this.treeData = res.data;
        this.expandNodes(this.treeData, 2);
        if (this.filterText) {
          this.$nextTick(() => {
            this.$refs.typeTree.filter(this.filterText);
          });
        }
      });
    },
    /* 展开节点树的指定层级 */
    expandNodes(nodes, level) {
      for (let node of nodes) {
        if (level > 1) {
          this.defaultExpandedKeys.push(node.id);
          if (node.children) {
            this.expandNodes(node.children, level - 1);
          }
        }
      }
    },
    /* 筛选分类树 */
    filterTreeNode(value, data) {
      if (!value) return true;
      return data[this.typeTreeProps.label].indexOf(value) !== -1;
    },
    /* 重置搜索 */
    searchReset() {
      this.filterText = '';
      this.loadData();
    },
    /* 条件搜索 */
    searchChange() {
      this.loadData();
    },
    /* 启停节点 */
    doSwitch({ data }) {
      let text = '';
      if (data.status == 1) {
        text = '确定停用选中类型?';
      } else {
        text = '确定启用选中类型?';
      }
      this.$confirm(text, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: data.id, status: data.status, projectId: data.projectId });
        })
        .then(() => {
          this.$message.success('操作成功!');
          this.loadData();
        });
    },
    /* 打开表单弹框 */
    openFromDialog(type, node) {
      this.selectedNode = {};
      if (type == 'addRoot') {
        this.formTitle = '新增一级类型';
        this.selectedNode = {
          formType: 'add',
          isRoot: true,
          projectId: this.projectId,
        };
      } else {
        let {
          level,
          data: currData,
          parent: { data: parentData },
        } = node;
        if (type == 'add') {
          this.formTitle = '新增下级类型';
          this.selectedNode = {
            formType: type,
            isRoot: false,
            projectId: this.projectId,
            parentId: currData.id,
            parentName: currData.name,
            parentCode: currData.code,
          };
        } else if (type == 'edit') {
          this.formTitle = '编辑';
          this.selectedNode = {
            formType: type,
            isRoot: level == 1,
            projectId: this.projectId,
            id: currData.id,
            name: currData.name,
            code: currData.code,
            sort: currData.sort,
          };
          if (level > 1) {
            this.selectedNode.parentId = parentData.id;
            this.selectedNode.parentName = parentData.name;
            this.selectedNode.parentCode = parentData.code;
          }
        }
      }
      this.isFormDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseFormDialog(done) {
      this.$confirm(' 是否关闭继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          if (typeof done == 'function') {
            done();
          } else {
            this.isFormDialogShow = false;
          }
        })
        .catch(() => {});
    },
    /* 表单操作导致的数据更新 */
    updateData() {
      this.loadData();
      this.isFormDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}

/* 控制树的水平方向的布局 */
::v-deep .custom-tree-node {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;

  i {
    margin-left: 20px;
  }
}

/* 控制树的行高 */
::v-deep .el-tree-node__content {
  height: 30px !important;
}
</style>
